import React from 'react'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { useSelector } from 'react-redux'
import selectIsIE from 'redux/selectors/selectIsIE'
import cx from 'classnames'

// Stolen padding from the accordion headers to make it look consistent
const SectionHeader = ({ section, expandedNodeTitle }) => {
  const isIE = useSelector(selectIsIE)

  return (
    <div
      className='w-100 ma0 pv0 pr6 f5 min-h3 shadow-none fw7 flex items-center justify-between white bg-suez-canal'
      style={{ paddingLeft: '2.75rem' }}
    >
      <span className={cx('lh-title', { 'ie-min-height-flex-items-center-fix': isIE })}>
        {expandedNodeTitle || section}
      </span>
      <ExpandLessIcon />
    </div>
  )
}

export default SectionHeader
